import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'

export const removeSOCSample = async ({ id }: { id: string }): Promise<void> => {
  await apiClient.delete(`${endpoints.monitoringSOCSamples}/${id}`)
}
